/**
 * Builds the official insurer-app Online Check-in handoff URI.
 *
 * The address is embedded verbatim to match the official praxis-check-in.de
 * generator byte for byte, which `KimAddressQrCode.test.ts` pins. Note the
 * open conflict recorded in `plans/frontdesk-release-review-fixes`: the eEB
 * plan (steps/06) describes this parameter as percent-encoded. Encoding it
 * would diverge from the generator output insurer apps are built against, so
 * the parity test wins until the discrepancy is settled with gematik/PKV.
 *
 * @since 1.0.0
 * @example
 * ```ts
 * buildOnlineCheckInQrUri("praxis@musterpraxis.kim.telematik")
 * ```
 */
export function buildOnlineCheckInQrUri(kimAddress: string): string {
  return `https://www.praxis-check-in.de/?mail=${kimAddress}`;
}
